import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pylon = defineConnector({
  identifier: "pylon",
  name: "Pylon",
  tagLine: "B2B customer support platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.usepylon\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Pylon API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to Pylon and navigate to **Settings > API**. Generate a new API token and copy it.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.usepylon.com/me",
  },
});
